import Typography from "@mui/material/Typography"
import { observer } from "mobx-react-lite/dist"
import { useProposalsEditStore } from "../ProposalsEditStore"
import ProposalsEditPaymentStore, { ProposalsEditPaymentStoreProvider } from "./ProposalsEditPaymentStore"
import useStore from "reusable/mobx-store-utils"
import { serviceRateTypeEnums } from "@gap/backend/app-services/services/models/ServiceRateTypesDto"
import ProposalsEditPaymentRateTypeBlock from "./ProposalsEditPaymentRateTypeBlock"

export default observer(function ProposalsEditPayment() {
   const proposalsEditStore = useProposalsEditStore()
   const proposalEditPaymentStore = useStore(sp => new ProposalsEditPaymentStore(sp), { proposalsEditStore })

   return <ProposalsEditPaymentStoreProvider store={proposalEditPaymentStore}>
      <Typography variant="h4">Pricing & Payment</Typography>
      <Typography variant="body1" sx={{ mt: 2 }}>Set your price and configure your payment options.</Typography>

      {serviceRateTypeEnums.map(rateType => <ProposalsEditPaymentRateTypeBlock rateType={rateType} key={rateType} />)}

   </ProposalsEditPaymentStoreProvider>
})
